<template>
  <b-container
    fluid
    :class="$style.landingContainer"
  >
    <header></header>
    <main :class="$style.mainContent">
      <div :class="$style.container">
        <img
          src="@assets/images/logo-404.png"
          :class="$style.logo404"
          alt="404 logo"
        />
        <h1 :class="$style.title">
          Sorry, we couldn't find that.
        </h1>
      </div>
      <div :class="$style.searchWrapper">
        <div v-if="!sitesLoaded">
          One moment, we're loading schools...
        </div>
        <input
          v-if="sitesLoaded"
          v-model="needle"
          :class="$style.search"
          placeholder="Find another school"
          @keyup="searchSchools(needle)"
          @change="searchSchools(needle)"
          @keypress="searchSchools(needle)"
        />
      </div>
      <div :class="$style.resultsWrapper">
        <div
          v-for="site in filteredSites"
          :key="site.id"
          :class="$style.result"
        >
          <a
            :href="`${site.slug}`"
            :class="$style.siteLink"
          >
            {{ site.name }}
            <font-awesome-icon
              :icon="['fal', 'external-link']"
              :class="$style.linkIcon"
            />
          </a>
        </div>
      </div>
    </main>
    <footer :class="$style.footer">
      Provided by RoaringSky inc. / All Rights Reserved / &copy;{{ new Date().getFullYear() }}
    </footer>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      needle: '',
      filteredSites: [],
      sitesLoaded: false,
    }
  },
  page: {
    title: '404',
    meta: [{ name: '404', content: '404' }],
  },
  computed: {
    ...mapGetters({
      sites: 'sites/getSites',
    }),
  },
  mounted() {
    this.fetchSites().then(() => {
      this.sitesLoaded = true
    })
  },
  methods: {
    ...mapActions({
      fetchSites: 'sites/fetchSites',
    }),
    searchSchools(needle) {
      if (this.needle.length >= 3) {
        const str = needle.toLowerCase()
        this.filteredSites = this.sites.filter(function (site) {
          return site.name.toLowerCase().indexOf(str) >= 0
        })
      } else {
        this.filteredSites = []
      }
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6.25rem;
}
.footer {
  justify-content: 0;
  padding: 0.625rem;
  font-size: 0.875rem;
  color: #ccc;
  text-align: center;
}
.landingContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #fff;
}
.logo404 {
  position: relative;
  top: -0.25rem;
  height: 40px;
  margin: 0 10px 0 0;
}
.mainContent {
  flex: 1;
}
.title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--brandColor);
  text-align: center;
}
.result {
  display: block;
  padding: 5px 0;
}
.resultsWrapper {
  justify-content: center;
  height: 200px;
  font-weight: 500;
  color: #fff;
  text-align: center;
}
.search {
  padding: 10px 20px;
  font-weight: 700;
  color: #e6046a;
  background: #fff;
  border-top: none;
  border-right: none;
  border-bottom: 2px solid #e6046a;
  border-left: none;
}
.search::placeholder {
  font-weight: 500;
  color: #666;
}
.searchWrapper {
  display: flex;
  justify-content: center;
  margin: 40px 0 30px 0;
}
.siteLink,
.siteLink:active,
.siteLink:visited {
  color: #e6046a !important;
}
</style>
